module.exports = __webpack_public_path__ + "static/media/pos-screen@2x.02d1bc31.png";